import OAuth2ImplicitGrant from 'ember-simple-auth/authenticators/oauth2-implicit-grant';

export default class AuthUrlHashAuthenticator extends OAuth2ImplicitGrant {}
